import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap';
import { DataTable } from 'primeng/primeng';
import { AppConfigService } from '../../../app.config';
import { DisplayModes } from '../../../models/enums';
import { HCP } from '../../../models/lookups/hcp.model';
import { OrganizationType } from '../../../models/lookups/organizationType.model';
import { Specialty } from '../../../models/lookups/speciality.model';
import { Page } from '../../../models/page.model';
import { AccountService } from '../../../services/account.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { Brick } from '../../../settings/models/brick.model';
import { HCPService } from '../hcp.service';
import { LookupsService } from '../../../services/lookups.service';

@Component({
  selector: 'crm-merge-hcp',
  templateUrl: './merge-hcp.component.html',
  styleUrls: ['./merge-hcp.component.css']
})
export class MergeHcpComponent implements OnInit {
  columns: any[] = [];
  searchText: string;
  search: any = {};
  totalItems: number = 0;
  countAllPages: number = 1;
  currntDownloadPage: number = 1;
  currentPage: number = 1;
  pageSize = this.appConfig.settings.pageSize;
  countryId: number;
  displayMode: DisplayModes = DisplayModes.Success;
  specialitys: Specialty[] = [];
  hcps: HCP[] = [];
  allList: HCP[] = [];

  selectedHcpItems: HCP[] = [];
  updateModel: boolean = false;
  public logo ="";
  @ViewChild('filterModal')
  filterModal: ModalDirective;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;
  addNew: boolean = false;
  viewMode: boolean = false;
  selectedHcpId;
  @Input() hcpId: number;
  @Output() closeEvent = new EventEmitter<boolean>();


  settings = {
    columns: {
      id: {
        title: 'ID'
      },
      name: {
        title: 'Name'
      },
      phone: {
        title: 'Phone'
      },
      organizationTypeName: {
        title: 'OrganizationType'
      },
      brick: {
        title: 'Brick'
      },
      territory: {
        title: 'Territory'
      }
    }
  };


  @ViewChild('dt') dataTable: DataTable;
  firstList: boolean = true;

  constructor(private alertService: AlertService, private lookupsService: LookupsService,
    private route: ActivatedRoute,
    private hcpService: HCPService,
    private readonly appConfig: AppConfigService,
    private translateService: AppTranslationService,
    private accountService: AccountService,
    private router: Router) {
  }

  ngOnInit() {
    this.getBSpecialitys()
    this.searchHcps();
    this.columns = [
      { field: 'id', header: 'Code', width: '5%' },
      { field: 'name', header: 'Name', width: '20%' },
      
      { field: 'specialityName', header: 'Speciality', width: '10%' },
       
    ];

  }
  logSelected() {
    console.log(this.selectedHcpItems);
  }
  back() {
    this.closeEvent.emit(true);
  }

  // a merge hides the selected HCPs and moves everything they own to this one - ask first, and let the user choose
  // whose rep link stays when both have one in the same business unit
  @ViewChild('confirmMergeModal')
  confirmMergeModal: ModalDirective;
  keepSurvivingRepLinks: boolean = true;
  merging: boolean = false;

  merge() {
    if (!this.selectedHcpItems || this.selectedHcpItems.length === 0) return;
    this.keepSurvivingRepLinks = true;
    this.confirmMergeModal.show();
  }

  confirmMerge() {
    this.merging = true;
    this.displayMode = DisplayModes.Loading;
    this.hcpService.mergeHCPs(this.hcpId, this.selectedHcpItems, this.keepSurvivingRepLinks).subscribe(response => {
      this.merging = false;
      this.confirmMergeModal.hide();
      this.alertService.showMessage("", this.translateService.getTranslation("clm.savedSuccessfully"), MessageSeverity.Success);
      this.displayMode = DisplayModes.Success;
      this.back();                       // close only once the server has merged - an error keeps the dialog open
    }, (error) => {
      this.merging = false;
      this.confirmMergeModal.hide();
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Error;
      this.alertService.showStickyMessage("Merge failed", "Nothing was merged:", MessageSeverity.Error, error);
    });
  } 

  getBSpecialitys() {
    this.displayMode = DisplayModes.Loading;
    this.lookupsService.getAllSpecialitys('').subscribe(response => {

      const results = response;
      this.specialitys = results as Specialty[];
      this.displayMode = DisplayModes.Success;

    }, () => {
      this.displayMode = DisplayModes.Error;
    });
  }
   

  searchHcps() {

    this.alertService.startLoadingMessage("", this.translateService.getTranslation("Searching"));
    this.displayMode = DisplayModes.Loading;
  
    let specialityId;
     
    if (this.search.speciality !== undefined && this.search.speciality !== null)
      specialityId = this.search.speciality.id;

    this.hcpService.SearchHCPs(this.search.searchText, specialityId, undefined, this.pageSize, this.currentPage, this.hcpId).subscribe(response => {
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Success;

      const result = response as Page;
      this.allList = result.items;
      this.hcps = [];
      result.items.forEach(x => {
        if (this.hcps.filter(y => y.id == x.id).length == 0)
          this.hcps.push(x);
      })

      this.totalItems = result.totalItems;
      this.countAllPages = Math.ceil(this.totalItems / 10000);
       
    }, err => {
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Error;
    });
  }

  pageChanged(event) {
   
    this.currentPage = event.first / event.rows + 1;
    if (!this.firstList)
      this.searchHcps();
    else
      this.firstList = !this.firstList;
  }


  openFilterModal() {
    this.filterModal.show();
  }

  showAddNew() {
    this.addNew = true;
  }

  hideFilterModal() {
    
    this.filterModal.hide();
  }

  searchFilterModal() {
    this.filterModal.hide();
    this.currentPage = 1;
    let paging = {
      first: ((this.currentPage - 1) * this.dataTable.rows),
      rows: this.dataTable.rows
    };
    this.searchHcps();
  }


}
